 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXT01_9781614230076_HALFTITLE from '@/components/Text/01_9781614230076_HalfTitle'
 import TEXT02_9781614230076_TITLE from '@/components/Text/02_9781614230076_Title'
 import TEXT03_9781614230076_COPYRIGHT from '@/components/Text/03_9781614230076_Copyright'
 import TEXT04_9781614230076_FRONTMATTER from '@/components/Text/04_9781614230076_Frontmatter'
 import TEXT05_9781614230076_CONTENTS from '@/components/Text/05_9781614230076_Contents'
 import TEXT06_9781614230076_FOREWORD from '@/components/Text/06_9781614230076_Foreword'
 import TEXT07_9781614230076_PREFACE from '@/components/Text/07_9781614230076_Preface'
 import TEXT08_9781614230076_ACKNOWLEDGEMENTS from '@/components/Text/08_9781614230076_Acknowledgements'
 import TEXT09_9781614230076_PROLOGUE from '@/components/Text/09_9781614230076_Prologue'
 import TEXT10_9781614230076_CH01 from '@/components/Text/10_9781614230076_CH01'
 import TEXT11_9781614230076_CH02 from '@/components/Text/11_9781614230076_CH02'
 import TEXT12_9781614230076_CH03 from '@/components/Text/12_9781614230076_CH03'
 import TEXT13_9781614230076_CH04 from '@/components/Text/13_9781614230076_CH04'
 import TEXT14_9781614230076_CH05 from '@/components/Text/14_9781614230076_CH05'
 import TEXT15_9781614230076_CH06 from '@/components/Text/15_9781614230076_CH06'
 import TEXT16_9781614230076_CH07 from '@/components/Text/16_9781614230076_CH07'
 import TEXT17_9781614230076_CH08 from '@/components/Text/17_9781614230076_CH08'
 import TEXT18_9781614230076_CH09 from '@/components/Text/18_9781614230076_CH09'
 import TEXT19_9781614230076_CH10 from '@/components/Text/19_9781614230076_CH10'
 import TEXT20_9781614230076_CH11 from '@/components/Text/20_9781614230076_CH11'
 import TEXT21_9781614230076_APPENDIX from '@/components/Text/21_9781614230076_Appendix'
 import TEXT22_9781614230076_APPENDIX1 from '@/components/Text/22_9781614230076_Appendix-1'
 import TEXT23_9781614230076_SOURCES from '@/components/Text/23_9781614230076_Sources'
 import TEXT24_9781614230076_AUTHORNOTE from '@/components/Text/24_9781614230076_AuthorNote'
 import TEXT25_9781614230076_BM from '@/components/Text/25_9781614230076_BM'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/05_9781614230076_Contents",
 			"name" : "Text/05_9781614230076_Contents",
 			"component" : TEXT05_9781614230076_CONTENTS
 		},
 		{
 			"path" : "/Text/06_9781614230076_Foreword",
 			"name" : "Text/06_9781614230076_Foreword",
 			"component" : TEXT06_9781614230076_FOREWORD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js